import { render, staticRenderFns } from "./lecture.vue?vue&type=template&id=21fb8500&"
import script from "./lecture.vue?vue&type=script&lang=js&"
export * from "./lecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports